import _ from 'lodash';
import '../../../css/svsr_styles.css'
import SRCard from './SRCard';
import React, { Component } from "react";


class SRCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0,
    };

    this.cards = [
      {
        title: "Title 1",
        paragraph: "This is the paragraph for the first box.",
        "srid": 236,
        "averageGuestBrochurePrice": 744.0,
                                "averageGuestPrice": 744.0,
                                "catid": 1,
                                "catname": "INTERIOR",
                                "code": "I",
                                "idBrandCode": "IF",
                                "igvtIncluded": "Y",
                                "includedPromos": null,
                                "label": "INTERIOR",
                               
      },
      {
        title: "Title 2",
        paragraph: "This is the paragraph for the second box.",
        "srid": 237,
        "averageGuestBrochurePrice": 874.0,
        "averageGuestPrice": 874.0,
        "catid": 2,
        "catname": "OCEAN VIEW",
        "code": "O",
        "idBrandCode": "O6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": "OCEAN VIEW"
       
      },
      {
        title: "Title 3",
        paragraph: "This is the paragraph for the third box.",
        "srid": 238,
        "averageGuestBrochurePrice": 1074.0,
        "averageGuestPrice": 1074.0,
        "catid": 3,
        "catname": "BALCONY",
        "code": "B",
        "idBrandCode": "BE",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": "DELUXE BALCONY",
        "idBrandCode": "MF",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": "MINI SUITE",
      },
      {
        title: "Title 4",
        paragraph: "This is the paragraph for the fourth box.",
        "srid": 239,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 5",
        paragraph: "This is the paragraph for the fifth box.",
        "srid": 240,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 6",
        paragraph: "This is the paragraph for the sixth box.",
        "srid": 241,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 7",
        paragraph: "This is the paragraph for the seventh box.",
        "srid": 242,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 8",
        paragraph: "This is the paragraph for the eighth box.",
        "srid": 243,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 9",
        paragraph: "This is the paragraph for the fifth box.",
        "srid": 244,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 10",
        paragraph: "This is the paragraph for the sixth box.",
        "srid": 245,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 11",
        paragraph: "This is the paragraph for the seventh box.",
        "srid": 246,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
      {
        title: "Title 12",
        paragraph: "This is the paragraph for the eighth box.",
        "srid": 247,
        "averageGuestBrochurePrice": 1479.0,
        "averageGuestPrice": 1479.0,
        "catid": 9,
        "catname": "MINI SUITE",
        "code": "M",
        "idBrandCode": "S6",
        "igvtIncluded": "Y",
        "includedPromos": null,
        "label": " SUITE",
      },
    ];
  }

  moveCarousel = (direction) => {
    const visibleCards = 3;
    const maxIndex = Math.max(this.cards.length - visibleCards, 0);

    this.setState((previousState) => {
      const nextIndex = previousState.currentIndex + direction;

      return {
        currentIndex: Math.min(Math.max(nextIndex, 0), maxIndex),
      };
    });
  };

  render_boxSample() {
    const { currentIndex } = this.state;

    const visibleCards = 5;
    const gap = 16;

    /*
      Each card occupies 1/5 of the visible width.
      The gap must also be included when moving the track.
    */
    const cardPercentage = 100 / visibleCards;

    const translateValue = `calc(
      -${currentIndex * cardPercentage}% -
      ${currentIndex * gap}px
    )`;

    const maxIndex = Math.max(this.cards.length - visibleCards, 0);

    return (
      <div className="carousel-container">
        <button
          type="button"
          className="carousel-button previous-button"
          onClick={() => this.moveCarousel(-1)}
          disabled={currentIndex === 0}
          aria-label="Previous card"
        >
          &#10094;
        </button>

        <div className="carousel-window">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(${translateValue})`,
            }}
          >
            {this.cards.map((card, index) => (
              <div className="carousel-box" key={index}>
                <h3>{card.title}</h3>
                <p>{card.paragraph}</p>
              </div>
            ))}
          </div>
        </div>

        <button
          type="button"
          className="carousel-button next-button"
          onClick={() => this.moveCarousel(1)}
      
          aria-label="Next card"
        >
          &#10095;
        </button>
      </div>
    );
  }

  /*sv crad design */
  render() {
    const { currentIndex } = this.state;

    const visibleCards = 5;
    const gap = 16;

    /*
      Each card occupies 1/5 of the visible width.
      The gap must also be included when moving the track.
    */
    const cardPercentage = 100 / visibleCards;

    const translateValue = `calc(
      -${currentIndex * cardPercentage}% -
      ${currentIndex * gap}px
    )`;

    const maxIndex = Math.max(this.cards.length - visibleCards, 0);
    const { cabincategories } = this.props
    if(cabincategories &&  (cabincategories.length >0) ){
        cabincategories.map((o, idx)=>{ o.paragraph = 'luxury room'})
        this.cards = cabincategories
        
    }else{
        this.cards = []
    }
    return (
      <div className="carousel-container">
        <button
          type="button"
          className="carousel-button previous-button"
          onClick={() => this.moveCarousel(-1)}
          disabled={currentIndex === 0}
          aria-label="Previous card"
        >
          &#10094;
        </button>

        <div className="carousel-window">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(${translateValue})`,
            }}
          >
            {this.cards.map((card, index) => (
                
                <SRCard pob={card} title={card.title} paragraph={card.paragraph}  ></SRCard>
              
            ))}
          </div>
        </div>

        <button
          type="button"
          className="carousel-button next-button"
          onClick={() => this.moveCarousel(1)}
         
          aria-label="Next card"
        >
          &#10095;
        </button>
      </div>
    );
  }

  /*end card design */
}

export default SRCarousel;